import React from "react";
// import "./Segment.css";
import Slider from "react-slick";
import { BASE_URL } from "../../../Components/Base_url/Base_Url";
import { useGlobalContext } from "../../../Components/Base_url/GobelContaxt";
import Loader from "../../../Components/Base_url/Loader";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";

const Segment = () => {
    const { segments, loading } = useGlobalContext();

    const settings = {
        dots: true,
        infinite: true,
        speed: 800,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2, arrows: true }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: false,
                    centerPadding: "0px"
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    arrows: false,
                    dots: true,
                    centerMode: false,
                    centerPadding: "0px"
                }
            }
        ]
    };

    return (
        <section className="segment-section py-5" id="services">
            <div className="container">
                <h2 className="segment-title text-center mb-3">Our Services</h2>
                <p className="segment-subtitle text-center mb-5">
                    We offer a wide range of transportation services to meet all your travel needs.
                </p>

                {loading ? (
                    <Loader />
                ) : (
                    <Slider {...settings} className="segment-slider">
                        {segments.map((service, index) => (
                            <div key={index} className="segment-item px-2">
                                <div className="card h-100 shadow-sm border-0 text-center p-3">
                                    <img
                                        src={
                                            service.img
                                                ? `${BASE_URL}${service.img}`
                                                : "/img/Imges Call-for -cabsss/logo-1  (2) (1).png"
                                        }
                                        alt={service.name}
                                        className="card-img-top mx-auto"
                                        style={{ height: "120px", objectFit: "contain", width: "auto" }}
                                    />
                                    <div className="segment-icon my-2">{service.icon}</div>
                                    <h5 className="card-title mt-2">{service.name}</h5>
                                    <p className="card-text">{service.extra}</p>
                                    <a href={service.link} className="btn btn-outline-primary mt-2">
                                        Learn More
                                    </a>
                                </div>
                            </div>
                        ))}
                    </Slider>
                )}
            </div>
        </section>
    );
};

export default Segment;
